import { useState } from 'react';
import { Link } from 'wouter';

export function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim().toLowerCase() }),
            });
            setSubmitted(true);
        } catch (err: any) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
            <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 shadow-xl">
                <div className="text-center mb-6">
                    <div className="text-4xl mb-4">🔑</div>
                    <h1 className="text-2xl font-bold text-slate-900 mb-2">Forgot Password</h1>
                    <p className="text-slate-500 text-sm">Enter your email and we'll send a reset link.</p>
                </div>

                {submitted ? (
                    <div className="text-center space-y-4">
                        <div className="bg-green-50 border border-green-200 text-green-700 rounded-lg p-4 text-sm">
                            If an account exists with that email, a reset link has been sent. Check your inbox.
                        </div>
                        <Link href="/login" className="text-primary hover:text-primary/80 text-sm font-medium transition-colors">
                            ← Back to Login
                        </Link>
                    </div>
                ) : (
                    <>
                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-700 rounded-md p-3 text-sm mb-6 text-center">{error}</div>
                        )}

                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div className="space-y-1">
                                <label htmlFor="email" className="text-sm font-medium text-slate-700">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    className="w-full bg-white border border-slate-300 rounded-md px-3 py-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com"
                                    required
                                    autoFocus
                                />
                            </div>

                            <button
                                type="submit"
                                className="h-12 w-full bg-primary hover:bg-primary/90 text-white rounded-lg font-semibold transition disabled:opacity-60"
                                disabled={loading}
                            >
                                {loading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                        </form>

                        <div className="text-center text-sm text-slate-500 mt-6">
                            <Link href="/login" className="text-primary hover:text-primary/80 transition-colors">← Back to Login</Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
